import React from 'react';
import ModalCustom from "@ui/modal/ModalCustom";
import MutateTasksMutateSingleVoyage from "@containers/singleVoyage/mutateVoyage/tasks/MutateTasksMutateSingleVoyage";
import PrimaryButtonSingleVoyage
    from "@containers/singleVoyage/ui/buttonts/primaryButtonSingleVoyage/PrimaryButtonSingleVoyage";
import {SxType} from "@baseTypes/sx/sxTypes";
import {useTranslation} from 'react-i18next';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';

const sx: SxType = {
    btn: {
        flexShrink: 0,
    }
}
const MutateTasksMutateSingleVoyageModal = () => {

    const {t} = useTranslation()



    return (
        <ModalCustom
            button={<PrimaryButtonSingleVoyage
                sx={sx.btn}
                variant={'secondary'}
                startIcon={<FormatListNumberedIcon/>}
            >
                {t('base.tasks')}
            </PrimaryButtonSingleVoyage>}
            component={<MutateTasksMutateSingleVoyage/>}
            initialFullScreenMode
        />
    )
};

export default MutateTasksMutateSingleVoyageModal;
